export const formatDOB = (day, month, year) => {
  const parsedDay = day.length === 1 ? `0${day}` : day;
  const parsedMonth = month.length === 1 ? `0${month}` : month;

  return `${parsedDay}/${parsedMonth}/${year}`;
};
